import script from "./SelectedSubject.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedSubject.vue?vue&type=script&setup=true&lang=ts"

import "./SelectedSubject.vue?vue&type=style&index=0&id=5403ee12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5403ee12"]])

export default __exports__